<template>
    <v-container class="pb-11 pt-9">
        <v-card class="banner d-flex flex-column flex-sm-row justify-space-between align-center align-sm-start">
            <img class="banner__img my-sm-8 mx-sm-7 mt-5" src="@/assets/covid.svg" alt="Unite against COVID-19"/>
            <img class="banner__govt my-5 my-sm-12 mx-sm-11" src="@/assets/new-zealand-government.svg" alt=""/>
            <!-- <h1 class="pb-6">
                <strong>COVID-19</strong> Novel Coronavirus
            </h1>
            <h2>Waimakariri district updates, information and advice.</h2> -->
        </v-card>
    </v-container>
</template>

<script>
    // import Alerts from './Alerts.vue';

    export default {
        components: {
        }
    }
</script>

<style scoped lang="scss">
    
    $card-outlined-border-width: 1px;
    $card-border-radius: 0;

    .banner {
        background: repeating-linear-gradient(
            -45deg,
            transparent,
            transparent 70px,
            #f8cd46 0,
            #f8cd46 140px
        );
        position: relative;

        &__img {
            width: 239px;
            height: 200px;

            @media (min-width: 600px) {
                width: 165px;
                height: 138px;
            }
        }

        h1 {
            font-size: 65px;
            font-weight: 300;
            letter-spacing: -0.7px;
            line-height: 1;

            strong {
                font-weight: 800;
            }
        }

        h2 {
            font-size: 21px;
            line-height: 30px;
            font-weight: 500;
        }
    }
</style>